import type { ComponentStyleConfig } from '@chakra-ui/theme';
import 'video-react/dist/video-react.css';
import {
  BaseBodyP3,
  BorderWidthXs,
  ColorsGrey800,
  FontFamilyDefault,
  LineHeights5xl,
  SpacingSm,
  SpacingXxs,
  TextInvertSubdued,
} from '../../generated/variables';

export const VideoPlayer: ComponentStyleConfig = {
  baseStyle: {
    controlBar: {
      color: `${TextInvertSubdued} !important`,
      height: 'auto  !important',
      width: '100%  !important',
      border: `${BorderWidthXs} solid ${ColorsGrey800}  !important`,
      borderBlockColor: `${ColorsGrey800}  !important`,
      padding: `${SpacingXxs}  !important`,
      fontFamily: `${FontFamilyDefault} !important`,
    },
    bigPlayButton: {
      display: 'flex',
      padding: SpacingSm,
      justifyContent: 'center !important',
      alignItems: 'center !important',
      gap: `${SpacingXxs}  !important`,
    },
    volumeButton: {},
    closedCaptionButton: {},
    audioDescriptinButton: {},
    fullScreenButton: {},
    playToggleButton: {
      color: `${TextInvertSubdued} !important`,
    },
    settingsButton: {},
    playbackRateMenuButton: {},
    timeDisplay: {
      fontSize: `${BaseBodyP3} !important`,
      lineHeight: `${LineHeights5xl} !important`,
      fontFamily: `${FontFamilyDefault} !important`,
    },
    progressControl: {
      /**
       * To do: make progress bar over top as per figma
       */
      // position: 'absolute !important',
      // left: '-2px !important',
      // height: '0px !important'
    },
    fullscreenToggle: {},
  },
  parts: [],
};
